import React from 'react';
import styles from './selling-offers-skeleton.module.scss';

const SellingOffersNegotiationColumnTopSkeleton: React.FC = () => {
  return (
    <div className={`${styles.sellingOffersSkeleton__negotiationColumnTop} ssc`}>
      <div className={styles.sellingOffersSkeleton__negotiationColumnTop__top}>
        <div className={styles.sellingOffersSkeleton__negotiationColumnTop__product}>
          <div className={styles.sellingOffersSkeleton__negotiationColumnTop__productImg}>
            <div className="ssc-square"></div>
          </div>

          <div className={styles.sellingOffersSkeleton__negotiationColumnTop__details}>
            <div className="ssc-line"></div>
            <div className="ssc-line w-60"></div>
            <div className="ssc-line w-90"></div>
          </div>
        </div>
      </div>

      <div className={styles.sellingOffersSkeleton__negotiationColumnTop__bottom}>
        <div className={styles.sellingOffersSkeleton__negotiationColumnTop__offers}>
          <div className="ssc-head-line"></div>
        </div>
      </div>
    </div>
  );
};

export default SellingOffersNegotiationColumnTopSkeleton;
